import React, { PropsWithChildren } from 'react';
import { Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import useStyles from './styles';

const NotifyInvestorsTooltip: React.FC<
  PropsWithChildren<{ title: string }>
> = ({ title, children }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.notifyInvestorsTooltipContainer}>
      <Tooltip title={title} arrow placement="top">
        <div className={classes.notifyInvestorsTooltip}>
          <span>Notify investors</span>
          <InfoOutlined style={{ fontSize: 18 }} />
        </div>
      </Tooltip>
      {children}
    </div>
  );
};

export default NotifyInvestorsTooltip;
